module.exports = function validateThreshold($table) {
  var $fields = $table.find("tfoot select");
  var values = $fields.map(function () { return $(this).val(); }).get();
  var duplicate = values.length > 0 && values.every(function (value) {
    return value !== "";
  }) && $table.children("tbody").children("tr").toArray().some(function (row) {
    var $keys = $(row).children('td[data-type="select-one"]');
    return values.every(function (value, index) {
      return $keys.eq(index).attr("data-val") === value;
    });
  });

  var errorId = $table.attr("id") + "-duplicate-error";
  $table.parent().find("#" + errorId).remove();
  if (duplicate) {
    $("<p>", {
      id: errorId,
      class: "govuk-error-message",
      role: "alert",
      tabindex: "-1",
      text: "Thresholds already exist for this grant section. Remove the existing row before adding new thresholds.",
    }).insertBefore($table).trigger("focus");
    return false;
  }
  return true;
};
